module.exports = userData => ({
  id: userData.id,
  email: userData.email,
  language: userData.language || 'en-US',
  tags: userData.tags,
  hasTwentyFourHourTimeFormat: userData.twentyfour_hour_time,
  imageDimensionsKey: userData.imagedimensions_key,
  messages: userData.messages || [],
  skip_empty_text_alert: userData.messages.includes(
    'remember_confirm_saving_modal'
  ),
  profile_groups: userData.profile_groups || [],
  s3_upload_signature: userData.s3_upload_signature,
  week_starts_monday: userData.week_starts_monday,
  twofactor: userData.twofactor,
  profiles_schedules_slots: userData.profiles_schedules_slots,
  hasEmailNotifications: {
    collaborationNotifications:
      userData.email_notifications.includes('weekly_digests') ||
      userData.email_notifications.includes('collaborationNotifications'),
    queueNotifications:
      userData.email_notifications.includes('buffer_empty') ||
      userData.email_notifications.includes('queueNotifications'),
    newsletterNotifications:
      userData.email_notifications.includes('buffer_tips') ||
      userData.email_notifications.includes('newsletterNotifications'),
    milestonesNotifications:
      userData.email_notifications.includes('celebrations') ||
      userData.email_notifications.includes('milestonesNotifications'),
    postFailureNotifications:
      userData.email_notifications.includes('update_failures') ||
      userData.email_notifications.includes('postFailureNotifications'),
    billingNotifications: userData.email_notifications.includes(
      'billingNotifications'
    ),
  },
  analyzeCrossSale: userData.is_analyze_customer,
  features: userData.features, // these are user features only, for org features (owner features) check org parser
  showCalendarAsHomepage: userData.features.includes('calendar_homepage_v2'),
});
